// extracted by mini-css-extract-plugin
module.exports = {"picker":"status-picker_picker__jktA6","option":"status-picker_option__T7M_C"};